/**
 * @ngdoc object
 *
 * @description
 * Available paths for which we accept websocket notifications
 */
const whitelistedPaths = [
    'apps',
    'app-instances',
    'app-integrations',
    'devices',
    'licenses',
    'users',
    'actions',
    'events',
    'activation-codes',
];

export default whitelistedPaths;



// WEBPACK FOOTER //
// ./scripts/common/constants/pathWhitelist.js